import { useTranslation } from 'react-i18next';

import { ModalName } from '../../../../enums';
import { Modal } from '../../../common';

export const LearnMoreModal = () => {
  const { t } = useTranslation();

  return (
    <Modal name={ModalName.LEAR_MORE} header={t('modal.learnMoreAboutPod.title')}>
      <span className="typography-title-2 text-text-primary">{t('modal.learnMoreAboutPod.bpAverage.title')}</span>
      <p className="typography-paragraph-3 text-text-secondary mb-6">
        {t('modal.learnMoreAboutPod.bpAverage.description')}
      </p>
      <span className="typography-title-2 text-text-primary">{t('modal.learnMoreAboutPod.bpPercentage.title')}</span>
      <p className="typography-paragraph-3 text-text-secondary mb-6">
        {t('modal.learnMoreAboutPod.bpPercentage.description')}
      </p>
      <span className="typography-title-2 text-text-primary">{t('modal.learnMoreAboutPod.bpType.title')}</span>
      <p className="typography-paragraph-3 text-text-secondary mb-6">
        {t('modal.learnMoreAboutPod.bpType.description')}
      </p>
    </Modal>
  );
};
